import React, { useState } from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {
  amber,
  blue,
  blueGrey,
  brown,
  cyan,
  deepOrange,
  deepPurple,
  green,
  grey,
  indigo,
  lightBlue,
  lightGreen,
  lime,
  orange,
  pink,
  purple,
  red,
  teal,
  yellow,
} from '@mui/material/colors';
import { alpha } from '@mui/material';
import { useUpdateEffect } from 'react-use';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
);

const COLOR = [
  blue[500],
  blue[300],
  blue[100],
  lightBlue[500],
  lightBlue[300],
  lightBlue[100],
  cyan[500],
  cyan[300],
  cyan[100],
  teal[500],
  teal[300],
  teal[100],
  green[500],
  green[300],
  green[100],
  lightGreen[500],
  lightGreen[300],
  lightGreen[100],
  lime[500],
  lime[300],
  lime[100],
  yellow[500],
  yellow[300],
  yellow[100],
  amber[500],
  amber[300],
  amber[100],
  orange[500],
  orange[300],
  orange[100],
  deepOrange[500],
  deepOrange[300],
  deepOrange[100],
  brown[500],
  brown[300],
  brown[100],
  grey[500],
  grey[300],
  grey[100],
  blueGrey[500],
  blueGrey[300],
  blueGrey[100],
  indigo[500],
  indigo[300],
  indigo[100],
  deepPurple[500],
  deepPurple[300],
  deepPurple[100],
  purple[500],
  purple[300],
  purple[100],
  pink[500],
  pink[300],
  pink[100],
  red[500],
  red[300],
  red[100],
];

const StackedBarChart = ({ borderColor, textColor, data9 }) => {
  const [data, setData] = useState({
    labels: [],
    datasets: [],
  });

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        ticks: {
          color: textColor,
        },
        grid: {
          color: borderColor,
        },
      },
      y: {
        stacked: true,
        ticks: {
          color: textColor,
        },
        grid: {
          color: borderColor,
        },
      },
    },
  };

  useUpdateEffect(() => {
    if (data9) {
      const { labels, data: ds } = data9;
      const datasets = ds.map(({ label, data: d, j }) => {
        return {
          label,
          data: d,
          backgroundColor: alpha(COLOR[j], 0.7),
          hoverBackgroundColor: COLOR[j],
          borderColor,
          borderWidth: 1,
          hoverOffset: 4,
        };
      });
      setData({ labels, datasets });
    }
  }, [data9]);

  return (
    <Bar
      options={options}
      data={data}
      onMouseDown={(e) => e.stopPropagation()}
    />
  );
};

export default StackedBarChart;
